import { useTranslations } from 'next-intl';

import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import PageBuilder from '@commons/pagebuilder';
import type { DrupalBlock, DrupalTerm } from '@commons/types/drupal';

/**
 * InsightTopicsList field block.
 */

const InsightTopicsListBlock = ({ content }: DrupalBlock<DrupalTerm[]>) => {
  const t = useTranslations('blocks.insightsDetailsPage');

  // Ensure content is an array or fallback to an empty array.
  const tags = Array.isArray(content) ? content : [];
  if (tags.length < 1) return null;

  const renderedTags = tags.map(PageBuilder.renderTerm);

  return (
    <>
      <Text color="grey-5" weight="medium" transform="uppercase" level="body-xs">
        {t('tags')}
      </Text>
      <Flex gap={6} wrap="wrap">
        {renderedTags}
      </Flex>
    </>
  );
};

export default InsightTopicsListBlock;
